export enum MetricsViewModeEnum  {
    GRAPH ='Graph',
    GRID = 'Grid'
}